import { AfterViewInit, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';

import { environmentOm } from '../../../../environment-om';
import { ReportsApi } from '../../../api/reports-api';
import { ReportHelper } from '../../report-helper';

@Component({
    selector: 'om-project-status-report',
    templateUrl: './projectStatusReport.html',
    styleUrls: ['../../reports.css', './projectStatusReport.css']
})

export class ProjectStatusReportComponent implements OnInit, AfterViewInit {

    @ViewChild('mcMap', { static: false }) mapRef: ElementRef<any>;
    defaultBasemap = {
        tileUrl: environmentOm.basemapURL + '/rest/services/basemaps/penndotbasemap/MapServer/tile',
        thumbnailTile: '/7/48/36',
        tileTemplate: '/{level}/{row}/{col}',
        title: 'PennDOT'
    };
    projectStatus;
    private costData;
    private totals;
    private readonly tipYears = [];
    isGenerating = false;
    error = false;
    errorMessage = this.reportHelper.reportErrorMessages.noReportData;
    private readonly todaysDate = new Date().toDateString();
    projectId: string;
    years;
    reportData;

    constructor(private readonly reportHelper: ReportHelper,
                private readonly reportsApi: ReportsApi,
                private readonly route: ActivatedRoute,
                titleService: Title) {
        titleService.setTitle(titleService.getTitle() + ' : Project Status Report');
    }

    ngOnInit() {
        this.isGenerating = true;
        this.route.paramMap.subscribe(async (x) => {
            this.projectId = JSON.parse(window.localStorage.getItem(x.get('id'))).projectId;
            await this.loadReport();
            this.isGenerating = false;
        });
    }

    ngAfterViewInit() {
        this.loadMap();
    }

    async loadMap() {
        const layerId = environmentOm.layers.filter(x => x.name === 'mpmsProjectsAll')[0].id;
        try {
            await this.mapRef.nativeElement.ready;
            await this.mapRef.nativeElement.setBasemapsFromConfig(this.defaultBasemap);
            const layerSettings = [{
                id: layerId,
                query: {
                    operator: 'AND', subqueries: [
                        { field: 'project_id', operator: '=', value: this.projectId }
                    ]
                },
                zoomToLayer: true
            }];
            this.mapRef.nativeElement.LayerService.addMapcoreLayersToMap(layerSettings);
        } catch (error) {}
    }

    private loadReport() {
        this.isGenerating = true;
        return this.reportsApi.getProjectStatusReportData(this.projectId).then((reportData: any) => {
            this.reportData = reportData;
            this.projectStatus = reportData.projectStatus;
            this.costData = reportData.costData;
            this.totals = reportData.costTotals;
            if (this.costData && this.costData.length) {
                this.calcTipYears(parseInt(this.costData[0].firstYear, 10));
            }
            this.isGenerating = false;
        }, (error) => {
            this.isGenerating = false;
            this.error = true;
        });
    }

    private calcTipYears(first) {
        let x;
        const maxIndex = 4;
        for (let i = 0; i < maxIndex; i++) {
            x = parseInt(first, 10) + i;
            this.tipYears.push(x);
        }
    }
}
